import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import AuthPageShell from './AuthPageShell';
import './Login.css';

const ForgotPassword = () => {
  /*
   * Asks for the USERNAME, not the email address.
   *
   * A parent reaches this screen because the login box rejected them, and most of the time it
   * rejected the username rather than the password. Resetting the password of an account they
   * are not naming cannot help: they get a working link, use it, and fail to log in exactly as
   * before. The server now refuses an unknown username here in the same words the login box
   * uses, so the dead end is reported instead of being dressed up as success.
   */
  const [username, setUsername] = useState('');
  const [error, setError] = useState('');
  const [sentTo, setSentTo] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setLoading(true);

    try {
      const res = await axios.post('/api/auth/forgot-password', { username });
      setSentTo(res.data?.sent_to || '');
      setSuccess(true);
    } catch (error) {
      setError(error.response?.data?.error || 'Failed to send password reset email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthPageShell>
      <div className="login-box">
        <h1>Back to School Forms</h1>
        <h2>Forgot Password</h2>
        {error && <div className="error-message">{error}</div>}
        {success ? (
          <div style={{ background: '#dfd', color: '#3a3', padding: '1rem', borderRadius: '4px', marginBottom: '1rem' }}>
            <p>
              {sentTo
                ? `A password reset link has been sent to ${sentTo}.`
                : 'A password reset link has been sent.'}
            </p>
            <p>Please check your email and click the link to reset your password.</p>
          </div>
        ) : (
          <>
            <p style={{ marginBottom: '1.5rem', color: '#666', textAlign: 'center' }}>
              Enter your username and we'll send a reset link to the email address on that account.
            </p>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Username</label>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  placeholder="Enter your username"
                  autoComplete="username"
                />
              </div>
              <button type="submit" className="btn-primary" disabled={loading}>
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
          </>
        )}
        <div style={{ marginTop: '1.5rem', textAlign: 'center' }}>
          {/* The way out of the dead end this screen now reports, rather than hides. */}
          <Link to="/forgot-username" style={{ color: '#667eea', textDecoration: 'none' }}>
            Don't know your username?
          </Link>
          <span style={{ color: '#aaa', margin: '0 0.5rem' }}>|</span>
          <Link to="/login" style={{ color: '#667eea', textDecoration: 'none' }}>
            Back to Login
          </Link>
        </div>
      </div>
    </AuthPageShell>
  );
};

export default ForgotPassword;




